






































import {Component, Prop, Vue,} from "vue-property-decorator";
import {UserProfile} from "../../../../api/models/UserProfile";
import UserIcon from "./UserIcon.vue";
import LiveSwitcher from "@share/web-conferences/components/people/LiveSwitcher.vue";
import {PresentersList} from "@share/web-conferences/types/PresentersList";
import {PresenterStatusChange} from "@share/web-conferences/types/PresenterStatusChange";
import HandIcon from '../../../../assets/svg/web-conferences/hand.svg';
import ContextControls from "@share/web-conferences/components/people/ContextControls.vue";
import {StreamInfo} from "@share/web-conferences/types/StreamInfo";
import {StreamTypes} from "@share/web-conferences/enums/StreamTypes";
import MicIcon from '../../../../assets/svg/mic.svg'
import CameraIcon from '../../../../assets/svg/wc-camera.svg'
import {AgoraInterface} from "@share/web-conferences/interfaces/AgoraInterface";
import { agoraGetter, tracksManagerGetter } from "@share/web-conferences/store/getters";
import {CurrentPresentation} from "@api/models/interfaces/web-conference/CurrentPresentation";
import ScreenSharingIcon from "@share/web-conferences/components/control-panel/share-icons/ScreenSharingIcon.vue";
import { TracksManagerCommonInterface } from "@share/web-conferences/types/TracksManagerCommonInterface";

@Component({
  name: "User",
  components: {ScreenSharingIcon, ContextControls, LiveSwitcher, UserIcon, MicIcon, HandIcon, CameraIcon}
})
export default class User extends Vue {
  @Prop() profile: UserProfile;
  @Prop() presenters: PresentersList;
  @Prop({default: true}) beingProcessed: boolean;
  @Prop({default: false}) joined: boolean;
  @Prop({default: false}) isSpeaker: boolean;
  @Prop({default: false}) allowBan: boolean;
  @Prop( {default: false}) raisedHand: boolean;
  @Prop() stateKey: string;
  @Prop({ default: true }) showControls: boolean;
  @Prop({ default: false }) prohibitMakingLive: boolean;
  @Prop() onlineUserIds: number[];
  @Prop({default: null}) currentPresentation: CurrentPresentation | null;

  get job(): string {
    return this.profile.job;
  }

  get role(): string {
    if (this.isOrganizer) {
      return this.$t('web-conferences.organizer') as string;
    }
    if (this.isSpeaker) {
      return this.$t('web-conferences.speaker') as string;
    }
    return '';
  }

  get isPresenter() {
    return this.profile.userId ? (this.presenters[this.profile.userId as number] ?? false) : false;
  }

  get isOrganizer(): boolean {
    return this.$store.getters.userIsAdmin(this.profile);
  }

  get isOnline(): boolean {
    return this.onlineUserIds.indexOf(this.profile.userId as number) >= 0;
  }

  get showDeviceButtons() {
    return this.joined && this.isPresenter;
  }

  get roleClasses() {
    return {
      'is-organizer': this.isOrganizer,
      'is-speaker': this.isSpeaker && !this.isOrganizer
    };
  }

  get agora(): AgoraInterface {
    return this.$store.getters[agoraGetter](this.stateKey);
  }

  get tracksManager(): TracksManagerCommonInterface {
    return this.$store.getters[tracksManagerGetter](this.stateKey);
  }

  get audioState() {
    return this.tracksManager?.audioStates[this.profile.userId as number] ?? false;
  }

  get videoState() {
    return this.tracksManager?.videoStates[this.profile.userId as number] ?? false;
  }

  get audioLabel() {
    return this.$t(this.audioState ? 'web-conferences.micOff' : 'web-conferences.micOn');
  }

  get videoLabel() {
    return this.$t(this.videoState ? 'web-conferences.videoOff' : 'web-conferences.videoOn');
  }

  get liveSwitcherDisabled() {
      return this.beingProcessed
          || (this.prohibitMakingLive && !this.isPresenter)
          || (!this.isOnline && !this.isPresenter && !this.raisedHand);
  }

  get isSharing() {
      return this.currentPresentation?.userId == this.profile.userId;
  }

  ban() {
    this.$emit('ban',this.profile);
  }

  onChanged(newValue: boolean) {
    this.$emit('liveChanged',{
      user: this.profile,
      isPresenter: newValue
    } as PresenterStatusChange );
  }

  onStreamChanged(streamType: StreamTypes) {
    this.$emit('streamChanged', {
      userId: this.profile.userId,
      isEnabled: !(streamType == StreamTypes.Audio ? this.audioState : this.videoState),
      streamType: streamType
    } as StreamInfo);
  }

}
